export default __webpack_public_path__ + "static/media/previous.4c6aa086.svg";